import { memo } from 'react';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { useFocusEffect } from '@bonanza-social/navigation';
import { useSelector } from '@bonanza-social/toolkit/state';
import { formatNumber } from '@bonanza-social/toolkit/utils';
import { Box, Text } from '@bonanza-social/moonlight';
import { TotalContributionsProps } from './TotalContributions.types';
import { selectCommunityJackpotEvents } from '../../../../../state';
import CommunityJackpotImage from '../../../../CommunityJackpotImage/CommunityJackpotImage';

const CONTAINER_HEIGHT = 31;

function TotalContributions({
  amount,
  animatable,
  children,
}: TotalContributionsProps) {
  const [event] = useSelector(selectCommunityJackpotEvents);
  const { progressBarTotalContributionsHolderUrl } = event;
  const translateY = useSharedValue(0);
  const style = useAnimatedStyle(() => ({
    transform: [
      {
        translateY: translateY.value,
      },
    ],
  }));

  useFocusEffect(() => {
    if (animatable) {
      translateY.value = CONTAINER_HEIGHT;
      translateY.value = withTiming(CONTAINER_HEIGHT / 2, {
        duration: 500,
        easing: Easing.in(Easing.ease),
      });

      return;
    }

    translateY.value = CONTAINER_HEIGHT / 2;
  });

  return (
    <Box
      height={CONTAINER_HEIGHT}
      animatedStyle={style}
      minWidth={Math.max((`${amount}`.length / 8) * 100, 90)}
      zIndex={1}
      centerContent
    >
      <CommunityJackpotImage
        position="absolute"
        inset={0}
        url={progressBarTotalContributionsHolderUrl}
        fallback="communityJackpot.contributions"
        contentFit="fill"
      />
      <Text variant="h6">
        {formatNumber(amount, {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
        })}
      </Text>
      {children}
    </Box>
  );
}

export default memo(TotalContributions);
